import { render, staticRenderFns } from "./avisoEdicao.vue?vue&type=template&id=8b5eac2a&scoped=true&"
import script from "./avisoEdicao.vue?vue&type=script&lang=js&"
export * from "./avisoEdicao.vue?vue&type=script&lang=js&"
import style0 from "./avisoEdicao.vue?vue&type=style&index=0&id=8b5eac2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5eac2a",
  null
  
)

export default component.exports